export default __webpack_public_path__ + "static/posBoss-a38e8c19eb731e093bb82a22b69180f7.png";